import React, { createContext, useState } from 'react';

const INITIAL_STATTE = {
	liveChatOpened: false,
	unreadChatCount: 0,
	openLiveChat: () => {},
	closeLiveChat: () => {},
	toggleLiveChat: () => {},
	incrementUnreadChatCount: () => {},
	clearUnreadChatCount: () => {}
};
const LiveChatContext = createContext(INITIAL_STATTE);

export const LiveChatProvider = ({ children }) => {
	const [liveChatOpened, setLiveChatOpened] = useState(false);
	const [unreadChatCount, setUnreadChatCount] = useState(0);

	const openLiveChat = () => {
		setLiveChatOpened(true);
	};
	const closeLiveChat = () => {
		setLiveChatOpened(false);
	};
	const toggleLiveChat = () => {
		setLiveChatOpened(prevState => !prevState);
	};
	const incrementUnreadChatCount = () => {
		setUnreadChatCount(prevState => prevState + 1);
	};
	const clearUnreadChatCount = () => {
		setUnreadChatCount(0);
	};

	return (
		<LiveChatContext.Provider
			value={{
				liveChatOpened,
				unreadChatCount,
				openLiveChat,
				closeLiveChat,
				toggleLiveChat,
				incrementUnreadChatCount,
				clearUnreadChatCount
			}}
		>
			{children}
		</LiveChatContext.Provider>
	);
};

export default LiveChatContext;
